import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=b475d7e8&scoped=true"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"
import style0 from "./catalog.vue?vue&type=style&index=0&id=b475d7e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475d7e8",
  null
  
)

export default component.exports